import React from 'react';
import MainSearchAPI from '../api/MainSearchAPI'; 
import { reactLocalStorage } from 'reactjs-localstorage';
import Button from 'react-bootstrap/Button';
import { FaPlus, FaCheck, FaTimes, FaMap, FaAngleDown, FaAngleUp } from 'react-icons/fa';
import Parse from 'html-react-parser';
import FieldController from '../controller/FieldController';
import FieldAudio from '../components/common/FieldAudio';
import Const from './Constants';
import Util from './Util';
import PropertyAPI from '../api/PropertyAPI';

class Display {

  /**
   * 
   * @param {*} value model info like lead, contact
   * @param {*} field name of field
   * @param {*} fields object in model fields
   * @returns 
   */
  static FieldValue = (value, field, fields, onlyText) => {
    if (!value) {
      return '';
    }
    let attributeType = null, options = null;
    if (field.includes(Const.Address) && field.includes(Const.Opt)) {
      const multiField = field.split(Const.Opt);
      field = multiField[1];
      attributeType = fields[multiField[0]].field_type;
      options = FieldController.getOptions({ field_type: field });
    } else {
      if (!fields[field]) return "";
      attributeType = fields[field].field_type;
      options = FieldController.getOptions(fields[field]);
    }
    if (attributeType === Const.Text
      || attributeType === Const.Number) {
      return value[field] && value[field] !== '' ? value[field] : '-';
    } else if (
      (attributeType === Const.TextArea || attributeType === Const.HTML) && onlyText) {
      const regex = /(<([^>]+)>)/gi;
      return value[field] ? value[field].replace(regex, '').replaceAll('&nbsp;', '') : '-';
    } else if (
      (attributeType === Const.Location)) {
      return value[field] ? value[field].split('~').filter(Boolean)[2] : '-';
    } else if (attributeType === Const.TextArea) {
      return value[field] && typeof value[field] === 'string' && value[field] !== ''
        ? value[field].includes('<') ? Parse(value[field]) : value[field]
        : '-';
    } else if (attributeType === Const.HTML) {
      return value[field] && value[field] !== '' ? Parse(value[field]) : '-';
    }
    else if (attributeType.includes(Const.MultiSelect)) {
      let val = value[field];
      val = val && val !== '~~' ? val.substring(1, val.length - 1).split(Const.Opt) : [''];
  if (field === 'property') {
    const ids = (value[field] && value[field] !== '~~')
      ? value[field].substring(1, value[field].length - 1).split(Const.Opt).filter(v => v !== '')
      : [];
    if (ids.length === 0) return '-';

    class PropertyNames extends React.Component {
      state = { names: [] };
      async componentDidMount() {
        const names = await Promise.all(
          ids.map(id => Display.getPropertyName(parseInt(id)))
        );
        this.setState({ names: names.filter(n => n !== '') });
      }
      render() {
        return this.state.names.length > 0 ? this.state.names.join(', ') : '...';
      }
    }
    return <PropertyNames />;
  } else if (options) {
        let tmp = '';
        for (let i = 0; i < val.length; i++) {
          const opt = options.find(opt => opt.value === parseInt(val[i]));
          tmp += opt ? (tmp !== '' ? ', ' + opt.label : opt.label) : '';
        }
        return tmp !== '' ? tmp : '-';
      }
    }
    else if (attributeType.includes(Const.Select)) {
      if (field === Const.Properties && attributeType === `${Const.Select}~${Const.Properties}`
        && value.property_name) {
        return value.property_name;
      } else {
        const opt = options.find(opt => opt.value === value[field]);
        return opt ? opt.label : '-';
      }
    }
    else if (attributeType === Const.DateTime) {
      return Util.serverStringToDisplayDateTime(value[field]);
    }
    else if (attributeType === Const.Date) {
      return Util.serverStringToDisplayDate(value[field]);
    }
    else if (attributeType === Const.SinglePhone) {
      const val = value[field];
      return val && val.includes(Const.Hhn) ? val.split(Const.Hhn)[1] : val;
    }
    else if (attributeType === Const.Email || attributeType === Const.Phone
      || attributeType === Const.Web || attributeType === Const.MultiValue) {
      const val = value[field];
      return val && val.length > 2 ? val.substring(1, val.length - 1).replace('~', ', ') : '-';
    }
    else if (attributeType === Const.Complete || attributeType === Const.Toggle) {
      return value[field] === Const.True ? Const.Yes : Const.No;
    }
    else if (attributeType === Const.Model) {
      return Display.ModelName(value);
    }
    else if (attributeType === Const.Location) {
      const LatLong = value[field] && value[field].includes(Const.Opt) ? value[field].split(Const.Opt) : null;
      return LatLong ? <a href={`https://maps.google.com/?q=${LatLong[0]},${LatLong[1]}`} target="_blank" rel="noreferrer">
        <FaMap />{LatLong[2]}</a> : '-';
    }
    else if (attributeType === Const.Module) {
      return Display.ModulLabelValue(value[field]);
    }
    else if (attributeType === Const.Address && field === Const.City) {
      const adds = value[attributeType];
      const cities = reactLocalStorage.getObject(Const.Cities);
      let tmp = '';
      for (let i = 0; adds && i < adds.length; i++) {
        const city = cities.find(city => parseInt(city.value) === parseInt(adds[i].city));
        tmp += city ? tmp !== '' ? ', ' + city.label : city.label : '';
      }
      return tmp !== '' ? tmp : '-';
    }
    else if (attributeType === Const.Address && field === Const.State) {
      const adds = value[attributeType];
      const states = reactLocalStorage.getObject(Const.States);
      let tmp = '';
      for (let i = 0; adds && i < adds.length; i++) {
        const state = states.find(state => parseInt(state.value) === parseInt(adds[i].state));
        tmp += state ? tmp !== '' ? ', ' + state.label : state.label : '';
      }
      return tmp !== '' ? tmp : '-';
    }
    else if (attributeType === Const.Address && field === Const.Country) {
      const adds = value[attributeType];
      const conts = reactLocalStorage.getObject(Const.Countries);
      let tmp = '';
      for (let i = 0; adds && i < adds.length; i++) {
        const cont = conts.find(cont => parseInt(cont.value) === parseInt(adds[i].country));
        tmp += cont ? tmp !== '' ? ', ' + cont.label : cont.label : '';
      }
      return tmp !== '' ? tmp : '-';
    }
    else if (attributeType === Const.Address && field === Const.Street) {
      const adds = value[attributeType];
      let tmp = '';
      for (let i = 0; adds && i < adds.length; i++) {
        const street = adds[i].street;
        tmp += street && street.length > 0 ? tmp !== '' ? ', ' + street : street : '';
      }
      return tmp !== '' ? tmp : '-';
    }
    else if (attributeType === Const.Address && field === Const.Pin) {
      const adds = value[attributeType];
      let tmp = '';
      for (let i = 0; adds && i < adds.length; i++) {
        const pin = adds[i].pin;
        tmp += pin && pin.length > 0 ? tmp !== '' ? ', ' + pin : pin : '';
      }
      return tmp !== '' ? tmp : '-';
    }
    else if (attributeType === Const.Address) {
      value = value[field];
      const cities = reactLocalStorage.getObject(Const.Cities);
      const states = reactLocalStorage.getObject(Const.States);
      const countries = reactLocalStorage.getObject(Const.Countries);
      let tmp = '';
      for (let i = 0; value && i < value.length; i++) {
        const tmpVal = value[i];
        tmp = tmp === '' ? value[i].street : tmp + '\n' + value[i].street;
        const city = cities.find(city => parseInt(city.value) === parseInt(tmpVal.city));
        if (city !== undefined) tmp = tmp === '' ? city.label : tmp + ', ' + city.label;
        const state = states.find(state => parseInt(state.value) === parseInt(tmpVal.state));
        if (state !== undefined) tmp = tmp === '' ? state.label : tmp + ', ' + state.label;
        const country = countries.find(country =>
          parseInt(country.value) === parseInt(tmpVal.country));
        if (country !== undefined) tmp = tmp === '' ? country.label : tmp + ', ' + country.label;
        tmp = tmp === '' ? value[i].pin : tmp + ', ' + value[i].pin;
      }
      return tmp;
    }
    else if (attributeType === Const.Duration) {
      let tmp = '';
      let secs = value[field] ? value[field] : 0;
      const hrs = Math.floor(secs / 3600) % 24;
      if (hrs > 0) {
        secs -= hrs * 3600;
        tmp = hrs + 'h';
      }

      const mins = Math.floor(secs / 60) % 60;
      if (mins > 0) {
        secs -= mins * 60;
        tmp += tmp !== '' ? ' ' + mins + 'm' : mins + 'm';
      }
      if (secs > 0) {
        tmp += tmp !== '' ? ' ' + secs + 's' : secs + 's';
      }
      return tmp !== '' ? tmp : '-';
    }
    else if (attributeType.includes(Const.MainModel)) {
      value = value[`${field}_main_model`];
      value = value && value.length > 2 ? value.substring(1, value.length - 1)
        .replace(Const.Opt, Const.Comn) : '';
      return value;
    }
    else if (attributeType === Const.Audio) {
      return value[field] && value[field].length > 1 ? <FieldAudio url={value[field]} /> : null;
    }
    else if (attributeType !== Const.Text && attributeType !== Const.TextArea
      && attributeType !== Const.Number && attributeType !== Const.Decimal) {
      return `${attributeType} Unknown`;
    }
    //display in word
    else if (attributeType === Const.Decimal) {
      if (['min_budget', 'max_budget', 'price', 'price_per_sqft', 'agreement_price'].includes(field)) {
        const numberText = Util.toTextFromNumber(value[field]);
        const formatToCurrency = Util.formatINRCurrency(value[field], { showCurrencyPrefix: true });
        return `${formatToCurrency}\n${numberText ? `(${numberText})` : ""}`;
      } else {
        return value[field];
      }
    }
    return value[field];
  };

  static ModelLabelValue = (modelName, value) => {
    const models = reactLocalStorage.getObject(Const.Model);
    if (!models[modelName]) return '-';
    if (!models[modelName].options) return '-';
    const option = models[modelName].options.find(option => option.value === value);
    return option ? option.label : '-';
  };

  static ModulLabelValue = modelNo => {
    const models = reactLocalStorage.getObject(Const.Model);
    const keys = Object.keys(models);
    const key = keys.find(key => models[key].model_no === modelNo);
    return key ? models[key].model_name : '-';
  };

  static MultiValueAction = (index, add, edit, remove) => {
    return index === -1 ?
      <div className="col-md-2 btnAdd">
        <Button variant="primary" onClick={add}><FaPlus /></Button>
      </div>
      :
      <div className="col-md-2">
        <Button variant="success" onClick={edit}> <FaCheck />
        </Button>
        <Button variant="danger" onClick={() => remove(index)}>
          <FaTimes />
        </Button>
      </div>
      ;
  };

  static MultiAction = (index, add, remove) => {
    return index === 0 ?
      <div className="col-md-2">
        <Button variant="primary" onClick={add}><FaPlus /></Button>
      </div>
      :
      <div className="col-md-2">
        <Button variant="danger" onClick={() => remove(index)}>
          <FaTimes />
        </Button>
      </div>
      ;
  };

  static UpDown = (index, length, up, down) => {
    if (index === 0 && index !== length - 1) {
      return <Button variant="secondary" onClick={() => down(index)}><FaAngleDown /></Button>;
    } else if (length !== 0 && index === length - 1) {
      return <Button variant="secondary" onClick={() => up(index)}><FaAngleUp /></Button>;
    } else if (index < length - 1) {
      return <>
        <Button variant="secondary" onClick={() => up(index)}><FaAngleUp /></Button>
        <Button variant="secondary" onClick={() => down(index)}><FaAngleDown /></Button>
      </>;
    }
    return null;
  };

  static ModelName = value => {
    let tmp = '';

    if (value && value.firstname) {
      tmp += !Util.isEmpty(value.firstname) ? value.firstname + ' ' : '';
      tmp += !Util.isEmpty(value.middlename) ? value.middlename + ' ' : '';
      tmp += !Util.isEmpty(value.lastname) ? value.lastname : '';
    } else if (value && value.model_no) {
      if (value.model_no === Const.Lead) {
        tmp = `${reactLocalStorage.getObject(Const.Model).lead.model_name} : `;
        tmp += !Util.isEmpty(value.lead_first) ? value.lead_first + ' ' : '';
        tmp += !Util.isEmpty(value.lead_midle) ? value.lead_midle + ' ' : '';
        tmp += !Util.isEmpty(value.lead_last) ? value.lead_last : '';
        tmp += !Util.isEmpty(value.lead_phone) ? ' : ' + Display.ShowPhone(value.lead_phone) : '';
      } else if (value && value.model_no === Const.Contact) {
        tmp = `${reactLocalStorage.getObject(Const.Model).contact.model_name} : `;
        tmp += !Util.isEmpty(value.cont_first) ? value.cont_first + ' ' : '';
        tmp += !Util.isEmpty(value.cont_midle) ? value.cont_midle + ' ' : '';
        tmp += !Util.isEmpty(value.cont_last) ? value.cont_last : '';
        tmp += !Util.isEmpty(value.cont_phone) ? ' : ' + Display.ShowPhone(value.cont_phone) : '';
      } else tmp = '-';
    }
    return tmp === '' ? '-' : tmp;
  };

  static replaceAll = (val, key, replace) => {
    if (!val) return '';
    while (typeof val === 'string' && val.includes(key)) {
      val = val.replace(key, replace);
    }
    return val;
  };

  static ShowPhone = val => val && val.length > 2 ? val.substring(1, val.length - 1).replace('~', ', ') : '-';
  static getPropertyName = (id) => {
    return new Promise((resolve, reject) => {
      PropertyAPI.get(id, (res) => {
        if (res && res.name) {
          resolve(res.name);
        } else {
          resolve('');
        }
      }, (err) => {
        console.error(err);
        resolve('');
      });
    });
  };


  static Name = (value) => {
    let tmp = '';
    tmp += !Util.isEmpty(value.firstname) ? value.firstname + ' ' : '';
    tmp += !Util.isEmpty(value.middlename) ? value.middlename + ' ' : '';
    tmp += !Util.isEmpty(value.lastname) ? value.lastname : '';
    return tmp === '' ? '-' : tmp;
  }

  static replaceAll = (val, key, replace) => {
    if(!val) return '';
    while(typeof val === 'string' && val.includes(key)) {
      val = val.replace(key, replace);
    }
    return val;
  }
}
export default Display;